// SearchSmall Application Entry Point
// This file sets up Hotwire (Turbo + Stimulus) and imports React components

// Hotwire Turbo - SPA-like page acceleration
import "@hotwired/turbo-rails"

// ActionText (Trix WYSIWYG editor)
import "trix"
import "trix/dist/trix.css"
import "@rails/actiontext"

// Stimulus - Modest JavaScript framework
import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

// Initialize Stimulus
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Register all Stimulus controllers from the controllers directory
const controllers = import.meta.glob("../controllers/**/*_controller.{js,ts}", { eager: true })
registerControllers(application, controllers)

// Import styles
import "../styles/application.css"

console.log("SearchSmall application loaded")

